var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxiconsAlertTriangleFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.45 4.18331C20.8666 3.13331 19.1166 3.13331 18.5333 4.18331L1.88331 34.1833C1.59998 34.7 1.59998 35.3333 1.89998 35.8333C2.19998 36.35 2.74998 36.65 3.33331 36.65H36.6666C37.25 36.65 37.8 36.3333 38.1 35.8333C38.2457 35.5834 38.3239 35.2998 38.3268 35.0105C38.3298 34.7212 38.2573 34.4361 38.1166 34.1833L21.45 4.18331ZM21.6666 31.6666H18.3333V28.3333H21.6666V31.6666ZM21.6666 25H18.3333V15H21.6666V25Z",
    fill: "#FFA629"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxiconsAlertTriangleFilled);
export default __webpack_public_path__ + "static/media/boxicons_alert-triangle-filled.586d6f8bd302a3c1ea1cc56f4971e2fd.svg";
export { ForwardRef as ReactComponent };